import script from "./Plan.vue?vue&type=script&lang=ts&setup=true"
export * from "./Plan.vue?vue&type=script&lang=ts&setup=true"

import "./Plan.vue?vue&type=style&index=0&id=6d50fd70&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d50fd70"]])

export default __exports__